import React from "react";
import { Menu } from "@mui/material";
import { Box } from "@mui/system";
import NotificationSVG from "../svg/NotificationFlagIcon";
import { TaskNotificationComponent } from "./TaskNotificationComponent";
import { useTranslation } from "react-i18next";

export const NotificationWrapperComponent = ({
  anchorEl,
  openMenu,
  closeMenu,
  notificationData,
}) => {
  const { t } = useTranslation();
  return (
    <Menu
      id="menu-appbar-notification"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openMenu}
      onClose={closeMenu}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          width: "500px",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 7.3,
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
    >
      <Box
        component="header"
        sx={{
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          m: "10px 0px 0px 10px",
        }}
      >
        <Box
          component="h1"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            marginTop: "0px",
            width: "225px",
            fontWeight: "400",
          }}
        >
          {t("Navbar.Notification")}
        </Box>
      </Box>
      <Box
        sx={{
          ml: "10px",
          mr: "10px",
          height: "calc(75vh)",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            m: "0px",
            p: "0px",
            borderRadius: "2px",
            position: "absolute",
            width: "inherit",
            left: "8px",
            right: "8px",
            backgroundColor: "#EBECF0",
            height: "2px",
          }}
        ></Box>
        <Box
          sx={{
            flexGrow: "1",
            minHeight: "0%",
            padding: "0px 8px",
          }}
        >
          <Box
            component="section"
            sx={{
              width: "100%",
              marginTop: "18px",
            }}
          >
            {Object.entries(notificationData).map(([day, block], index) => (
              <React.Fragment key={index}>
                <Box
                  component="p"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    color: "#6B778C",
                    m: 0,
                    textTransform: "uppercase",
                    mb: "6px",
                  }}
                >
                  {day}
                </Box>
                {block.map((iterator, idx) => (
                  <TaskNotificationComponent props={iterator} key={idx} />
                ))}
              </React.Fragment>
            ))}
          </Box>
        </Box>
        <Box
          sx={{
            margin: "0px 24px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: "10px 0px 10px",
            }}
          >
            <NotificationSVG width="40" height="40" />
            <Box
              component="p"
              sx={{
                fontSize: "14px",
                lineHeight: "20px",
                width: "225px",
                textAlign: "center",
              }}
            >
              {t("Navbar.NotificationBody")}
            </Box>
          </Box>
        </Box>
      </Box>
    </Menu>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/NotificationWrapperComponent.js